import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import { Round } from "@tento-ui/components/round";

import type { DecoratorBody } from "../page-decorators";

// Ephemeral, out-of-model promo pill (see escape-hatches.md). Campaign copy lives
// here, never in the PageModel, so it is never SSR'd or indexed. An elevated
// std-round chip overlaid over the hero's top padding (absolute, no layout
// space) so attaching post-hydration shifts nothing. No hover scale.

const PROMO_LABEL = "New · Introducing Lona 0.1 →";
const PROMO_HREF = "https://blog.lona.so/introducing-lona-0.1";
const PROMO_MARKER = "lona.promo-pill";

export const promoPillDecorator: DecoratorBody = {
  attach($host: HTMLElement): void {
    if ($host.querySelector(`[data-page-decorator="${PROMO_MARKER}"]`)) return;

    // Anchor absolute children to the page root without disturbing its layout.
    if (getComputedStyle($host).position === "static") {
      $host.style.position = "relative";
    }

    const $overlay = document.createElement("div");
    $overlay.dataset.pageDecorator = PROMO_MARKER;
    $overlay.assignStyles({
      position: "absolute",
      top: "24px",
      left: "0px",
      right: "0px",
      display: "flex",
      justifyContent: "center",
      pointerEvents: "none", // never intercept hero interaction
      // Sit above the hero but BELOW the sticky marketing-header (z-index: 10),
      // so the nav always draws over the pill where they overlap at the top.
      zIndex: "5",
    });

    const $label = document.createElement("span");
    $label.textContent = PROMO_LABEL;
    $label.assignStyles({
      whiteSpace: "nowrap",
      fontSize: "13px",
      fontWeight: "600",
      letterSpacing: "0.01em",
      color: "var(--bg)",
      padding: "9px 18px",
    });

    // Prominence comes from a filled slate background, not the shadow.
    // Darker slate (same hue as --slate-gray #4a4e69, ~15% darker).
    const $pill = Round.makeWith({
      bg: "#3f4259",
      continuous: { smoothing: 0.6 },
      radius: 16,
      shadow: "0 1px 4px rgba(0,0,0,0.12)",
    });
    $pill.assignStyles({
      width: "max-content",
      cursor: "pointer",
      pointerEvents: "auto",
    });
    $pill.appendChild($label);
    GESTURE_MANAGER.addPointerEvent($pill, {
      onClick: () => window.location.assign(PROMO_HREF),
    });

    $overlay.appendChild($pill);
    $host.appendChild($overlay);
  },
  detach: null,
};
